import ProdutoEstoqueConferenciaModel from "../models/produtoEstoqueConferenciaModel";
import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

export default class ProdutoEstoqueConferenciaService extends IService<ProdutoEstoqueConferenciaModel> {
    constructor() {
        super("ProdutoEstoqueConferencia");
    }

    public listProdutosVerificados(model: Array<ProdutoEstoqueConferenciaModel>): Promise<Response> {
        //@ts-ignore
        return nfetch(`/${this.controllerName}/ListProdutosVerificados`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(model),
        })
            .then((response: Response) => {
                if (response.ok) {
                    return response;
                } else {
                    return this.mensagemErro(response, "error");
                }
            })
            .catch(() => {});
    }
}
